import React from 'react';

import {HAS_WINDOW} from 'eventbrite_design_system/utils/dom';

import LocationAutocompleteInternal from './LocationAutocompleteInternal';
import LocationAutocompleteGoogle from './LocationAutocompleteGoogle';

export default function LocationAutocomplete(props) {
    if (HAS_WINDOW && props.isGoogleLocationAutocompleteEnabled) {
        return <LocationAutocompleteGoogle {...props} />;
    }

    return <LocationAutocompleteInternal {...props} />;
}
